module.exports = __webpack_public_path__ + "img/Talent Boards.e91ca5e4.svg";